export default __webpack_public_path__ + "static/media/20_tag_vending-machine.bf975198.svg";